import { RouterActionTypes } from './router.action.types';
export var NavigateToState = function (stateName, params, transitionOptions, openInNewWindow) { return ({
    type: RouterActionTypes.NAVIGATE_TO_STATE,
    payload: {
        StateName: stateName,
        Params: params,
        TransitionOptions: transitionOptions,
        OpenInNewWindow: openInNewWindow
    }
}); };
//# sourceMappingURL=navigateToState.action.js.map